import { render, staticRenderFns } from "./BotImageMessage.vue?vue&type=template&id=4ddd1e8c&scoped=true"
import script from "./BotImageMessage.vue?vue&type=script&lang=js"
export * from "./BotImageMessage.vue?vue&type=script&lang=js"
import style0 from "./BotImageMessage.vue?vue&type=style&index=0&id=4ddd1e8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ddd1e8c",
  null
  
)

export default component.exports